import axios from "axios"; // 引用axios
import config from "@/api/config";
import {
    ElMessage, ElMessageBox, ElLoading
} from 'element-plus'
import VueCookies from 'vue-cookies'
import router from '@/router'

let isUpgrade=false
let service = null
var ip = function () {
    if (/^(\d+)\.(\d+)\.(\d+)\.(\d+)$/.test(window.location.hostname)) {
        if (RegExp.$1 < 256 && RegExp.$2 < 256 && RegExp.$3 < 256 && RegExp.$4 < 256)
            return true
    } else {
        return false
    }
}
if (ip()) {
    let origin = window.location.origin
    let length = origin.indexOf(':', 8)
    let url = origin.substring(0, length + 1) + String(Number(origin.substring(length + 1, origin.length)) - 1)
    localStorage.setItem('ipUrl', url)
    service = axios.create({
        baseURL: url,
        timeout: 60000 // request timeout
    })
} else if (window.location.host.indexOf('2617') != -1) {
    //else if( window.location.host.indexOf('2617') != -1 ||  window.location.host.indexOf('localhost') != -1){
    service = axios.create({
        baseURL: config.baseUrl.test,
        timeout: 60000 // request timeout
    })
} else {
    service = axios.create({
        baseURL: config.baseUrl.dev,
        timeout: 60000 // request timeout
    })
}



service.defaults.retry = 1; //重试次数
service.defaults.shouldRetry = (error) => true; //重试条件，默认只要是错误都需要重试
service.interceptors.request.use( //请求拦截器
    config => {
        config.headers['session'] = VueCookies.get("session") ?? localStorage.getItem('session') ?? sessionStorage.getItem("session") // 让每个请求携带自定义token 请根据实际情况自行修改
        config.headers['zone'] = VueCookies.get("zone") ?? localStorage.getItem('zone') ?? sessionStorage.getItem("zone") // 让每个请求携带自定义token 请根据实际情况自行修改
        return config
    },
    error => {
        console.log(error) // for debug
        return Promise.reject(error)
    }
)
/*
 * 0: 成功
 * >0: 业务异常32位字母数字的字符串：业务异常
 * -1: 未登录
 * -2: 参数错误
 * -3: 服务器内部错误
 * -4: 服务器未实现这个功能
 * -8: 没有权限
 * -9: 权限超出了作用范围
 * */
service.interceptors.response.use( //响应拦截器
    res => {
        const status = res.data.status
        if (status == -1) {
            if ((window.location.host.indexOf('localhost')) !== -1) {
                VueCookies.remove("session");
            } else {
                var url = (document.domain).split(".");
                var arrUrl = '.' + url[2] + '.' + url[3]
                VueCookies.remove("session", '/', arrUrl);
            }
            VueCookies.remove("zone");
            //返回登录页
            router.push({
                name: 'login'
            });
            VueCookies.remove("district");
        } else if (status == 0) {
            return res.data
        } else {
            if (status) {
                if ((res.config.url == "user/addZoneUser" || res.config.url == "user/addDivUser") && status != 0) {
                    ElMessage({
                        message: res.data.phrase + '。 not found ' + status,
                        type: 'error',
                    })
                    return res.data
                }
                if (status == '9aa5e47366e74320a934e8ea8124db98') {
                    if (isUpgrade == false && res.config.url != "public") {
                        isUpgrade=true
                        ElMessageBox.alert(res.data.phrase, '网站升级维护中', {
                            confirmButtonText: '确定',
                            type: 'error',
                        });
                    } 
                     return res.data
                }
                else if (status == 3 && res.data.phrase == "exists") {
                    res.data.phrase = "选取的文件与已上传文件重名" + '。 not found ' + status
                } else if (status == '-6') {
                    res.data.phrase = "服务器繁忙" + '。 not found ' + status
                } else if (status == '-2' || status == '-3' || status == '-4' || status == '-8' || status == '-9') {
                    if (VueCookies.set.length == 1) {
                        console.log(VueCookies, VueCookies.get(), VueCookies.set.length)
                        return
                    }
                    if (res.config.url == "/div/import" && status == '-8') {
                        ElMessageBox.alert('当前状态下不可导入公开表' + '。 not found ' + status, '提示', {
                            confirmButtonText: '确定'
                        })
                    } else if (res.config.url == "user/edit" && status == '-2') {
                        res.data.args.forEach(el => {
                            //el.name == 'email' ? res.data.phrase = '邮箱格式错误' : res.data.phrase = "系统出现错误，若有未保存成功的数据请复制当前未保存成功的数据，刷新页面后重试。如果问题仍然存在，请联系技术人员。给您造成的不便深表歉意。" + status
                            el.name == 'email' ? ElMessageBox.alert('邮箱格式错误' + '。 not found ' + status, '提示', { confirmButtonText: '确定' }) : ElMessageBox.alert('系统出现错误，若有未保存成功的数据请复制当前未保存成功的数据，刷新页面后重试。如果问题仍然存在，请联系技术人员。给您造成的不便深表歉意。' + ' not found ' + status, '提示', { confirmButtonText: '确定' })

                        })
                    } else if (status == '-8') {
                        ElMessageBox.alert('暂无权限' + '。 not found ' + status, '提示', {
                            confirmButtonText: '确定'
                        })
                    } else if (status == '-2') {
                        ElMessageBox.alert('参数错误' + '。 not found ' + status, '提示', {
                            confirmButtonText: '确定'
                        })
                    } else if (status == '-9') {
                        ElMessageBox.alert('当前账号无此权限，可能您已经用其他账号登录了，而这个页面还是用之前账号打开的，所以导致权限范围错误。如果您需要同时操作两个账号的数据，可以分别使用两种不同的浏览器。' + '。 not found ' + status, '提示', {
                            confirmButtonText: '确定'
                        })
                    } else {
                        ElMessageBox.alert('系统出现错误，若有未保存成功的数据请复制当前未保存成功的数据，刷新页面后重试。如果问题仍然存在，请联系技术人员。给您造成的不便深表歉意。' + ' not found '+ status, '提示', {
                            confirmButtonText: '确定'
                        })
                    }
                }else if (status == -7 && window.location.host.indexOf('2617') == -1 && window.location.host.indexOf('localhost') == -1) {
                    res.config.baseURL = 'http://yjsgk.top:2615/'
                    var backoff = new Promise(function (resolve) {
                        resolve();
                    });

                    return backoff.then(function () {
                        return service(res.config);
                    });
                } else if (status == -5 || status == -10) {
                    //延时处理
                    var backoff = new Promise(function (resolve) {
                        resolve();
                    });

                    return backoff.then(function () {
                        return service(res.config);
                    });

                } else if (status == -4 || status == 1) {
                    return res.data
                } else {
                    if(res.config.url != 'div/tuihui'){
                        ElMessage({
                            message: res.data.phrase + '。 not found ' + status,
                            type: 'error',
                            duration: 0,
                            showClose: true,
                        })
                    }
                    return res.data
                }
            }
            if (res.config.url == "/div/downloadRaw") {
                return res
            } else {
                return res.data
            }
        }
    },
    error => {
        //超时网络出错的时候重试
        if (error.message !== 'Network Error') {
            if (error.config.url == "/div/downloadRaw") {
                ElMessage({
                    message: '未上传对应表',
                    duration: 5 * 1000
                })
            } else if (error.message.indexOf('12000') > -1 || error.message.indexOf('6000') > -1) {
                ElMessage({
                    message: '网络超时',
                    type: 'error',
                    duration: 5 * 1000
                })
            } else {
                ElMessage({
                    message: error.message,
                    type: 'error',
                    duration: 5 * 1000
                })
            }

        }
        // console.log(error,error.config.url)
        var config = error.config;

        if (error.response) {
            // if(error.response.status == 408){
            //     localStorage.setItem('downLoadType',true)
            // }
            // 判断404状态码
            
            if (error.config.url == "/div/downloadRaw" && error.response.status == 404) {
                return Promise.reject(error);
            }
            if (error.response.status != 404 && error.response.status != 408) {
                return Promise.reject(error);
            }
            if(error.response.status == 404){
                config.baseURL = 'http://yjsgk.top:2615/'
            }
        } else {
            if(config.baseURL == 'http://yjsgk.top:2615/'){
                ElLoading.service({ fullscreen: true })
                ElMessage({
                    message: '访问失败',
                    type: 'error',
                    duration: 5 * 1000
                })
            }else{
                config.baseURL = 'http://yjsgk.top:2615/'
            }
            // if (error.message.indexOf('timeout') <= 0) {
            //     return Promise.reject(error);
            // }
        }

        // 判断是否配置了重试
        if (!config || !config.retry) {
            return Promise.reject(error);
        }
        /*if (!config.shouldRetry || typeof config.shouldRetry != 'function') {
            return Promise.reject(error);
        }
        //判断是否满足重试条件
        if (!config.shouldRetry(error)) {
            return Promise.reject(error);
        }*/

        // 设置重置次数，默认为0
        config.__retryCount = config.__retryCount || 0;

        // 判断是否超过了重试次数
        if (config.__retryCount >= config.retry) {
            return Promise.reject(error);
        }

        //重试次数自增
        config.__retryCount += 1;

        //延时处理
        var backoff = new Promise(function (resolve) {
            resolve();
        });

        //重新发起axios请求
        if(window.location.host.indexOf('2617') == -1 && window.location.host.indexOf('localhost') == -1){
            return backoff.then(function () {
                return service(config);
            });
        }
    }
)

/*axios.interceptors.response.use(undefined, (error) => {
    
});*/
export default service